module.exports = __webpack_public_path__ + "img/Zhomebie03.437878b9.png";